import React from 'react';
import { Tabs, Tab, Stack, Typography  } from '@mui/material';
import { BoltRounded } from '@mui/icons-material';

function ReviewTabs({ selectedTab, setSelectedTab, variant, physicianNames = {}, logUserAction }) {

    function handleTabChange(value) {
        setSelectedTab(value);
        logUserAction({ action: `viewed_${variant}_tab`, data: { tab: value } });
    }    
    
    const labelValues = {
        peer_comparison: [
            { label: 'My Card', value: 'my_card' },
            { label: 'Comparison', value: 'comparison' },
            { label: 'Peer Card', value: 'peer_card' }
        ],
        card_review: [
            { label: (
                <Stack direction='row' alignItems='center'>
                    <BoltRounded /> 
                    <Typography variant="heavy">Optimizations</Typography>
                </Stack>
            ), value: 'optimizations' },
            { label: 'Analysis', value: 'analysis' },
            { label: 'Full Card', value: 'full_card' }
        ],
        card_comparison: [
            { label: physicianNames?.first || 'Physician A', value: 'physician_a' },
            { label: 'Comparison', value: 'comparison' },
            { label: physicianNames?.second || 'Physician B', value: 'physician_b' }
        ],
        // Future variants can be added here
    };

    return (
        <Tabs variant="fullWidth" value={selectedTab} onChange={(e, value) => handleTabChange(value)}>
            {labelValues[variant].map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
        </Tabs>
    );
}

export default ReviewTabs;